import { AudioOptionButtonState } from './VoiceControl/AudioOptionButton/AudioOptionButton.const';

export const getVocalGuideButtonState = (
  controlsDisabled: boolean,
  isVocalGuideAvailable: boolean,
  isVocalGuideActive: boolean,
): AudioOptionButtonState => {
  if (controlsDisabled || !isVocalGuideAvailable) {
    return AudioOptionButtonState.DISABLED;
  }

  return isVocalGuideActive ? AudioOptionButtonState.ACTIVE : AudioOptionButtonState.INACTIVE;
};
